import React from "react";
import ReactDOM from "react-dom";
import { ThemeProvider } from "@material-ui/styles";
import { CssBaseline } from "@material-ui/core";

// Configurazione globale di moment.js per l'italiano
import moment from "moment";
import "moment/locale/it";

import Themes from "./themes";
import App from "./components/App";
import * as serviceWorker from "./serviceWorker";
import { LayoutProvider } from "./context/LayoutContext";
import { UserProvider } from "./context/UserContext";
import { NotificationsProvider } from "./context/NotificationContext";
import { LeadsProvider } from "./context/LeadsContext";

// Configura moment.js per l'italiano
moment.locale("it");

ReactDOM.render(
  <LayoutProvider>
    <UserProvider>
      <NotificationsProvider>
        <LeadsProvider>
          <ThemeProvider theme={Themes.default}>
            <CssBaseline />
            <App />
          </ThemeProvider>
        </LeadsProvider>
      </NotificationsProvider>
    </UserProvider>
  </LayoutProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
